import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const headingStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(16), pxToRem(16), pxToRem(18), pxToRem(18)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(3)],
    textTransform: 'uppercase',
    marginBottom: '0px',
    [`@media (max-width: ${sizes.container.md})`]: {
        textAlign: 'center'
    }
}
export const textStyle = {
    marginBottom: '0px',
    marginTop: pxToRem(10),
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        textAlign: 'center',
        width: pxToRem(316)
    }
}
export const addAddressButtonStyle = {
    marginTop: [pxToRem(20), pxToRem(20), pxToRem(25), pxToRem(25)],
    backgroundColor: 'cav_red',
    color: 'white',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        backgroundColor: 'white',
        color: 'cav_red'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(308)
    }
}
